import { useMemo } from "react";
import { motion } from "motion/react";

const LOGO_CLOUD_BASE = "/assets/logo_cloud";

const LOGOS = [
  { name: "Logo 1", src: `${LOGO_CLOUD_BASE}/image.png` },
  { name: "Logo 2", src: `${LOGO_CLOUD_BASE}/image_1.png` },
  { name: "Logo 3", src: `${LOGO_CLOUD_BASE}/image_2.png` },
  { name: "Logo 4", src: `${LOGO_CLOUD_BASE}/image_3.png` },
  { name: "Logo 9", src: `${LOGO_CLOUD_BASE}/image_8.png` },
  { name: "Logo 10", src: `${LOGO_CLOUD_BASE}/image_9.png` },
  { name: "Logo 11", src: `${LOGO_CLOUD_BASE}/image_10.png` },
  { name: "Logo 13", src: `${LOGO_CLOUD_BASE}/image_12.png` },
  { name: "Logo 12", src: `${LOGO_CLOUD_BASE}/image_11.png` },
  { name: "Logo 5", src: `${LOGO_CLOUD_BASE}/image_4.png` },
  { name: "Logo 6", src: `${LOGO_CLOUD_BASE}/image_5.png` },
  { name: "Logo 7", src: `${LOGO_CLOUD_BASE}/image_6.png` },
  { name: "Logo 8", src: `${LOGO_CLOUD_BASE}/image_7.png` },
];

const LOGO_HEIGHT = "4rem";
const LOGO_WIDTH = "10rem";

/** Approximate width of one full set (8 logos + gaps) for seamless loop */
const CAROUSEL_LOOP_WIDTH_PX = 8 * 160 + 7 * 40;

export default function LogoCloud() {
  const duplicatedLogos = useMemo(() => [...LOGOS, ...LOGOS], []);

  return (
    <div className="relative z-20 flex w-full flex-col items-center justify-center overflow-hidden px-4 py-16 md:px-8 md:py-40 lg:px-16">
      <p className="text-sm font-semibold uppercase tracking-wider text-gray-500 mb-3">
        Trusted By Teams At
      </p>
      <div className="relative w-full max-w-full">
        <motion.div
          className="flex gap-16 md:gap-24"
          animate={{ x: [0, -CAROUSEL_LOOP_WIDTH_PX] }}
          transition={{
            x: {
              repeat: Infinity,
              repeatType: "loop",
              duration: 30,
              ease: "linear",
            },
          }}
        >
          {duplicatedLogos.map((logo, idx) => (
            <div
              key={`${logo.name}-${idx}`}
              className="shrink-0"
              style={{ height: LOGO_HEIGHT, width: LOGO_WIDTH }}
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="h-full w-full object-contain filter"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
}
